import isEqual from 'lodash/isEqual';
import type { Directive } from 'vue';

import { type Dictionary, touchOnClick, VALIDATION_EVENT_MODIFIERS, validationHandler } from '@emobg/web-utils';

export const Validate: Directive<HTMLElement, unknown> = {
  beforeMount(el, binding) {
    validationHandler(el, binding as Dictionary);
  },

  updated(el, binding) {
    const { value, oldValue } = binding;

    if (!isEqual(value, oldValue)) {
      validationHandler(el, binding as Dictionary);
    }
  },

  unmounted(el) {
    el.removeEventListener(VALIDATION_EVENT_MODIFIERS.validate, () => ({}));
    el.removeEventListener(VALIDATION_EVENT_MODIFIERS.fill, () => ({}));
    el.removeEventListener(VALIDATION_EVENT_MODIFIERS.select, () => ({}));
    el.removeEventListener(VALIDATION_EVENT_MODIFIERS.selectMultiple, () => ({}));
    el.removeEventListener(VALIDATION_EVENT_MODIFIERS.reset, () => ({}));
    el.removeEventListener(VALIDATION_EVENT_MODIFIERS.click, () => {
      touchOnClick(el);
    });
  },
} as const;
